import { gql } from '@src/lib/gql'

export const ADVISOR_PAYOUT_BALANCE = gql`
  query AdvisorPayoutBalance {
    advisorPayoutBalance {
      totalBalanceUsd
      availableBalanceUsd
      pendingBalanceUsd
      payoutMinUsd
      connectEnabled
      stripeConnectStatusKey
      stripeConnectAccountId
      stripeConnectCountry
      connectCountryOptions {
        code
        name
      }
      connectAccountType
      connectModel
      supportsPlatformPayout
    }
  }
`
